import { render, staticRenderFns } from "./WithdrawalRecord.vue?vue&type=template&id=deced94a&scoped=true&"
import script from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalRecord.vue?vue&type=style&index=0&id=deced94a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deced94a",
  null
  
)

export default component.exports